"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./SideDrawer.css");

var _styles = {
  "container": "SideDrawer__container___2m3e8",
  "left": "SideDrawer__left___2vI9a",
  "header": "SideDrawer__header___3Ij8F",
  "alert-message": "SideDrawer__alert-message___1MRxG",
  "bottom": "SideDrawer__bottom___1A_Zr",
  "header-main-content": "SideDrawer__header-main-content___14mJz",
  "header-content": "SideDrawer__header-content___3Aryp",
  "main-content": "SideDrawer__main-content___3xngP",
  "padding": "SideDrawer__padding___1ckF9",
  "full-height": "SideDrawer__full-height___EZbqO",
  "footer-content": "SideDrawer__footer-content___3-gVg",
  "footer": "SideDrawer__footer___17Kdt",
  "drawer-actions-padding": "SideDrawer__drawer-actions-padding___1K2w_",
  "drawer-actions-border": "SideDrawer__drawer-actions-border___Y_6SH",
  "alert-top": "SideDrawer__alert-top___2a-3X",
  "alert-bottom": "SideDrawer__alert-bottom___BWI-B",
  "backdrop": "SideDrawer__backdrop___1Fva5",
  "show": "SideDrawer__show___208a6",
  "portal": "SideDrawer__portal___pslU_"
};

const styles = _bind.default.bind(_styles);

const createRootElement = id => {
  const rootContainer = document.createElement('div');
  rootContainer.setAttribute('id', id);
  return rootContainer;
};

const addRootElement = rootElem => {
  document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
};

const usePortal = (id, left) => {
  const rootElemRef = (0, _react.useRef)();
  (0, _react.useEffect)(function setupElement() {
    const existingParent = document.querySelector(`#${id}`);
    const parentElem = existingParent || createRootElement(id);

    if (!existingParent) {
      addRootElement(parentElem);
    }

    parentElem.appendChild(rootElemRef.current);
    return function removeElement() {
      rootElemRef.current.remove();

      if (!parentElem.childElementCount) {
        parentElem.remove();
      }
    };
  }, [id]);
  const portal_classname = styles('portal', {
    left
  }).split(' ');

  const getRootElem = () => {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
      rootElemRef.current.classList.add(...portal_classname);
    }

    return rootElemRef.current;
  };

  return getRootElem();
};

var _default = usePortal;
exports.default = _default;